// Auto-generated normalizer for table: Puesto
export function puestoNormalize(row) {
  return {
    idPuesto: row.idPuesto ?? row.IdPuesto ?? row["idPuesto"] ?? row["IdPuesto"] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row["nombre"] ?? row["Nombre"] ?? "",
    descripcion: row.descripcion ?? row.Descripcion ?? row["descripcion"] ?? row["Descripcion"] ?? "",
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row["idEmpresa"] ?? row["IdEmpresa"] ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? row["nombreEmpresa"] ?? row["NombreEmpresa"] ?? "",
    activo: row.activo ?? row.Activo ?? row["activo"] ?? row["Activo"] ?? true,
  };
}
